import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Binda = lazy(() => import("@/pages/elavtal/Binda"));

export const Route = createFileRoute("/elavtal/binda")({
  head: () => seoHead("/elavtal/binda", { description: "Att binda elpriset ger trygghet men kostar ofta mer än månadspris. Här går vi igenom när det lönar sig att binda elavtalet." }),
  component: () => <Binda />,
});
